import { render } from "./SlowMovingReport.vue?vue&type=template&id=61184354&scoped=true"
import script from "./SlowMovingReport.vue?vue&type=script&lang=js"
export * from "./SlowMovingReport.vue?vue&type=script&lang=js"

import "./inventoryReport.css?vue&type=style&index=0&id=61184354&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61184354"]])

export default __exports__